<script>
  export let text;
</script>

<div class="ribbon">{text}</div>

<style>
  .ribbon {
    display: inline-block;
    transform: translateX(-100%);
    text-align: left;
    position: relative;
    background-color: black;
    border-color: #805031;
    background-color: var(--accent);
    color: #fff;
    left: calc(100% + 12px);
    top: 12px;
    padding: 4px 24px;
    margin: 0;
    min-width: max-content;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    z-index: 4;
    font-size: 12px;
  }

  .ribbon:after {
    position: absolute;
    content: "";
    top: 100%;
    background-color: transparent;
    left: auto;
    right: 0;
    border-style: solid;
    border-width: 14px 12px 0 0;
    border-color: transparent;
    border-top-color: inherit;
  }
</style>
